import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance.js";

export const cancelTeacherBooking = createAsyncThunk(
  "teacherBookings/cancelTeacherBooking",
  async (bookingId, thunkAPI) => {
    try {
      const { data } = await axiosInstance.patch(
        `/teacher/bookings/cancel/${bookingId}`
      );
      return { bookingId, ...data };
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Cancellation failed"
      );
    }
  }
);

// 📥 Архивация вручную
export const archiveTeacherBooking = createAsyncThunk(
  "teacherBookings/archiveTeacherBooking",
  async (bookingId, thunkAPI) => {
    try {
      await axiosInstance.patch(`/teacher/booking/${bookingId}/archive`);
      return bookingId;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Archiving failed"
      );
    }
  }
);

// 📤 Возврат из архива
export const unarchiveTeacherBooking = createAsyncThunk(
  "teacherBookings/unarchiveTeacherBooking",
  async (bookingId, thunkAPI) => {
    try {
      await axiosInstance.patch(`/teacher/booking/${bookingId}/unarchive`);
      return bookingId;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Unarchive failed"
      );
    }
  }
);

export const fetchTeacherBookings = createAsyncThunk(
  "teacherBookings/fetchTeacherBookings",
  async ({ mode = "active", page = 1 }, thunkAPI) => {
    try {
      const { data } = await axiosInstance.get(
        `/teacher/bookings?mode=${mode}&page=${page}&limit=10`
      );
      return { mode, ...data }; // data = { bookings, total, totalPages, currentPage }
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch teacher bookings"
      );
    }
  }
);
